module.exports = __webpack_public_path__ + "static/media/icomoon.890642b5.ttf";